import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { ITrack } from '../../../../Interface/track'
import { SsrService } from '../../../../services/ssr.service'
import { TracksService } from '../../../../services/tracks.service'

@Component({
  selector: 'bmcore-hot-new-tracks',
  templateUrl: './bmcore-hot-new-tracks.component.html',
  styleUrls: ['./bmcore-hot-new-tracks.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreHotNewTracksComponent implements OnInit {
  pageSize = 12
  tracks: ITrack[] = []

  constructor(
    private tracksService: TracksService,
    private ssrService: SsrService
  ) {}

  ngOnInit(): void {
    this.ssrService.wait('bmcore-hot-new-tracks: tracksService.getHotNewBeats')
    this.tracksService.getHotNewBeats(this.pageSize).subscribe(res => {
      this.ssrService.ready('bmcore-hot-new-tracks: tracksService.getHotNewBeats')
      this.tracks = res.items
    })
  }
}
